import * as React from "react"
import { useRouteMatch } from "react-router-dom"
import { CategoryType } from "@digits-graphql/frontend/graphql-bearer"
import routes from "src/frontend/routes"

export function useVendorCustomerCustomization() {
  const isCustomers = !!useRouteMatch(routes.customerDirectory.parameterizedPath)

  return React.useMemo(
    () => ({
      pluralLabel: isCustomers ? "Customers" : "Vendors",
      singularLabel: isCustomers ? "Customer" : "Vendor",
      displayKey: isCustomers ? "User01" : "Building02",
      newDisplayKey: isCustomers ? "UserPlus01" : "Building02",
      defaultCategoryType: isCustomers ? CategoryType.Income : CategoryType.Expenses,
      isCustomers,
    }),
    [isCustomers]
  )
}
